import axios from 'axios'
import { http } from './http';
import alertMessage from '../utils/alertMessage'
import { API_BASE_URL } from '../constants/appConstant';
import auth from './auth';

export const exportFile = (url, params, filename,callbackFun) => {
  let authInfo = auth.getAuthInfo();

  axios.post(API_BASE_URL + url, params, {
    headers: {
      "Content-Type": "application/json;utf-8",
      "Authorization": `Bearer ${authInfo.token}`,
      "PSP-Authorization": `${authInfo.pspToken}`,
      "Auth-Type":'ssofed'
    },
    responseType: 'blob'
  }).then(res => {
      const blob = new Blob([res.data], {
        type: 'application/octet-stream',
      });
      if (typeof window.navigator.msSaveBlob !== 'undefined') {
        window.navigator.msSaveBlob(blob, filename);
      } else {
        const blobUrl = window.URL.createObjectURL(blob);

        const eLink = document.createElement('a');
        eLink.style.display = 'none';
        eLink.href = blobUrl;
        eLink.download = filename || '';
        if (filename === '') {
          eLink.target = '_blank';
        }
        document.body.appendChild(eLink);
        eLink.click();
        document.body.removeChild(eLink);
        window.URL.revokeObjectURL(blobUrl);
      }
    callbackFun()
  })
    .catch(error => {
      // alertMessage.error(error.message)
      alertMessage.error('Failed！Timed Out!')
      callbackFun(error)
  });
}
export const exportTemplate = (url,filename)=>{
  let authInfo = auth.getAuthInfo();
  axios.post(API_BASE_URL + url, {},{
    headers: {
      "Content-Type": "application/json;utf-8",
      "Authorization": `${authInfo.token}`,
      "PSP-Authorization": `${authInfo.pspToken}`
    },
    responseType: 'blob'
  }).then(res => {
    const blob = new Blob([res.data], {
      type: 'application/octet-stream',
    });
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(blob, filename);
    } else {
      const blobUrl = window.URL.createObjectURL(blob);

      const eLink = document.createElement('a');
      eLink.style.display = 'none';
      eLink.href = blobUrl;
      eLink.download = filename || '';
      if (filename === '') {
        eLink.target = '_blank';
      }
      document.body.appendChild(eLink);
      eLink.click();
      document.body.removeChild(eLink);
      window.URL.revokeObjectURL(blobUrl);
    }
  })
}
export const uploadFile = (url, file, callback) => {
  let authInfo = auth.getAuthInfo();
  axios.post(API_BASE_URL + url,file,{
    headers:{
      "Content-Type": "application/json;utf-8",
      "Authorization": `${authInfo.token}`,
      "PSP-Authorization": `${authInfo.pspToken}`
    }
  }).then(res => {
    callback && callback(res)
  })
}
export const downloadFile = (url, filename) => {
  http
    .post(url, filename)
    .then(res => {
      if (res.code !== 0) {
        alertMessage.error('The requested resource does not exist.');
        return;
      }
      const blob = new Blob([res.data], {
        type: 'application/octet-stream',
      });
      if (typeof window.navigator.msSaveBlob !== 'undefined') {
        window.navigator.msSaveBlob(blob, filename);
      } else {
        const blobUrl = window.URL.createObjectURL(blob);
        const eLink = document.createElement('a');
        eLink.style.display = 'none';
        eLink.href = blobUrl;
        eLink.download = filename || '';
        if (filename === '') {
          eLink.target = '_blank';
        }
        document.body.appendChild(eLink);
        eLink.click();
        document.body.removeChild(eLink);
        window.URL.revokeObjectURL(blobUrl);
      }
    })
    .catch(() => {
      alertMessage.error('The requested resource does not exist.');
    });
};

